const constructionId = {
  state: {
    constructionId: null,
    rebarList: [],
  },
  mutations: {
    constructionIdChange: function(state, constructionId) {
      return (state.constructionId = constructionId);
    },
    rebarListChange: function(state, rebarList) {
      return (state.rebarList = rebarList);
    },
  },
  getters: {
    getConstructionId: function(state) {
      return state.constructionId;
    },
    getRebarList: function(state) {
      return state.rebarList;
    },
  },
  actions: {
    setConstructionId(commit, constructionId) {
      commit("constructionIdChange", constructionId);
    },
    setRebarList(commit, rebarList) {
      commit("rebarListChange", rebarList);
    },
  },
};
export default constructionId;
